/**
 * `mirror` — **measured, and the second correction.** A *configured* mirror ("Subitems Status"
 * on the sandbox board) is offered six conditions, shaped like the column it mirrors; an
 * *unconfigured* one ("Mirror", empty settings) is not offered at all. The list below is the
 * configured case; `filterSql` still refuses when the mirror has no source, so an
 * unconfigured column offers the rows and matches nothing rather than crashing.
 *
 * `is only` / `is anything but` are offered and not modelled (no public operator).
 */
import { IS_EMPTY, IS_NOT_EMPTY, IS_NOT_ONE_OF, IS_ONE_OF, TEXT_IS, TEXT_IS_NOT, } from '../filter-conditions.js';
export const mirrorFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    TEXT_IS,
    TEXT_IS_NOT,
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map